"use client";

import { useSearchParams } from "next/navigation";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { ButtonGroup } from "ui/core/button-group";
import { ToggleButtons } from "ui/widget/toggle-buttons";

import { getMetricPROptions } from "../data/metric-pr-options";
import { MetricPR } from "../types";

export const MetricToggleButtons = () => {
  const { lang } = useLang();
  const { updateQuery } = useUpdateQuery();
  const searchParams = useSearchParams();
  const metricPR = (searchParams.get("metricPR") ?? "industryPR") as MetricPR;
  const options = getMetricPROptions({ lang });

  const handleMetricPRChange = (value: string) => {
    updateQuery({
      name: "metricPR",
      value,
    });
  };

  return (
    <>
      {/* Desktop */}
      <div className="hidden md:block">
        <ToggleButtons
          itemClassName="rounded-lg text-zinc-500 hover:text-zinc-800"
          selectedItemClassName="bg-sky-100 shadow-none font-bold text-sky-600 hover:text-sky-600"
          fullWidth={false}
          value={metricPR}
          options={options}
          onChange={handleMetricPRChange}
        />
      </div>

      {/* Mobile */}
      <div className="md:hidden">
        <ButtonGroup
          className="min-w-[280px]"
          value={metricPR}
          options={options}
          onButtonClick={handleMetricPRChange}
        />
      </div>
    </>
  );
};
